import { SafeJSON } from './../shared/safe-json';
import { CaseIdentifier } from './../shared/case-identifier';
import { FileNumberUtil } from './../shared/file-number-util';

export class JuvenileSearchCase {
    json: any;
    caseIdentifier: CaseIdentifier;
    moreCases: JuvenileSearchCase[];
    moreCasesFlag = false;
    countyName = '';
    caseNumber = '';
    caseStatus = '';

    constructor(json: any) {
        if (json !== '') {
            this.caseIdentifier =
                new CaseIdentifier('JUVENILE',
                    json.countyName,
                    json.caseNumber);
            this.json = json;
            this.moreCases = [];
            this.moreCasesFlag = false;
            this.populateMoreCases();
        }
    }

    getCaseIdentifier(): CaseIdentifier {
        return this.caseIdentifier;
    }

    setCaseIdentifier(caseIdentifier: CaseIdentifier): void {
        this.caseIdentifier = caseIdentifier;
    }

    isJuvenileAliasName(): boolean {
        let juvenileAliasName: any = SafeJSON.get('juvenileAliasName', this.json);
        return juvenileAliasName;
    }

    getJuvenileName(): string {
        let juvenileName: any = SafeJSON.get('juvenileName', this.json);
        return juvenileName;
    }

    getJuvenileAliasCount(): number {
        let count: number = SafeJSON.get('juvenileAliasCount', this.json);
        return count;
    }

    getNCJoinNumber(): string {
        let ncJoinNumber: any = SafeJSON.get('ncJoinNumber', this.json);
        return ncJoinNumber;
    }

    getDateOfBirth(): string {
        return SafeJSON.get('juvenileDateOfBirth', this.json);
    }

    getCaseCounty(): string {
        if (SafeJSON.getWithDefault('countyName', this.json) !== '-') {
            return SafeJSON.get('countyName', this.json);
        } else {
            return this.countyName;
        }
    }

    setCaseCounty(countyName: string): void {
        this.countyName = countyName;
    }

    getCaseNumber(): string {
        if (SafeJSON.getWithDefault('caseNumber', this.json) !== '-') {
            return SafeJSON.get('caseNumber', this.json);
        } else {
            return this.caseNumber;
        }
    }

    setCaseNumber(caseNumber: string): void {
        this.caseNumber = caseNumber;
    }

    getCaseStatus(): string {
        if (SafeJSON.getWithDefault('caseStatus', this.json) !== '-') {
            let caseStatus: any = SafeJSON.get('caseStatus', this.json);
            return caseStatus;
        } else {
            return this.caseStatus;
        }
    }

    setCaseStatus(caseStatus: string): void {
        this.caseStatus = caseStatus;
    }

    getCaseStatusDescription(): string {
        let caseStatus: string = SafeJSON.get('caseStatus', this.json);

        if (caseStatus === 'OP') {
            return 'OPEN';
        }

        if (caseStatus === 'CL') {
            return 'CLOSED';
        }
    }

    populateMoreCases() {
        this.moreCases = [];
        // if(SafeJSON.getWithDefault('juvenileCases', this.json) !== '-') {
        let obj: any = SafeJSON.get('juvenileCases', this.json);
        for (const juvenileCase of obj) {
            let caseNumber: string = SafeJSON.get('caseNumber', juvenileCase);
            let countyName: string = SafeJSON.get('countyName', juvenileCase);
            let caseStatus: string = SafeJSON.get('caseStatus', juvenileCase);

            let value = new JuvenileSearchCase('');
            let caseIdentifier = new CaseIdentifier('JUVENILE', countyName, caseNumber);
            value.setCaseIdentifier(caseIdentifier);
            value.setCaseNumber(caseNumber)
            value.setCaseCounty(countyName)
            value.setCaseStatus(caseStatus);
            this.moreCases.push(value);
        }
        // }
    }

    getMoreCases(): JuvenileSearchCase[] {

        return this.moreCases;
    }

    isMoreCases(): boolean {
        return this.moreCases.length > 0;
    }

    getMoreCasesFlag(): boolean {
        return this.moreCasesFlag;
    }

    showMoreCases() {
        this.moreCasesFlag = true;
    }

    hideMoreCases() {
        this.moreCasesFlag = false;
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-search-case.ts